module.exports = __webpack_public_path__ + "static/media/19ESCAP47.956f46e6.jpg";